import Swal from "sweetalert2";

const SwalError = (text:string)=>{
    SwalClose()
    Swal.fire({
        text:text,
        icon:"error",
        confirmButtonText : 'تایید',
        title : 'خطا'

    })
}
const SwalLoading = ()=>{
    Swal.fire({
        text:'در حال بارگزاری',
        showConfirmButton:false,
        allowOutsideClick : false
    })
}
const SwalConferm = (message : string)=>{
  return   Swal.fire({
        title : 'اخطار',
        icon : "warning",
        showConfirmButton : true,
        text : message,
        confirmButtonText : 'تایید',
        cancelButtonText :'لغو',

    })
}
const SwalSuccess = (message? :  string) =>{
    return Swal.fire({
        title:'تایید',
        timer : 2000,
        icon:'success',
        text:message != null ? message :  'عملیات با موفقیت انجام شده',
        position:'center',
        showConfirmButton:false
    })
}
const SwalInputType1 = (object :  Promise<unknown>)  =>{
      const bind =async ()=>{
        await   Swal.fire({
              title: 'عنوان مورد نظر خود را انتخاب نمایید ',
              input: 'radio',
              showCancelButton : true,
              cancelButtonText : 'لغو',
              inputOptions: object,
              confirmButtonText : 'تایید',
              inputValidator: (value) => {
                  if (!value) {


                      return 'لطفا یکی از گزینه ها را انتخاب کنید !'
                  }


              }
          })
      }
    const result =  bind()
    return result

}
const SwalClose = ()=>Swal.close()
export {SwalError,SwalLoading,SwalClose,SwalConferm,SwalSuccess,SwalInputType1}